module.exports = __webpack_public_path__ + "img/9.98387b37.png";